import { Component } from 'react';

import classNames from 'classnames';

import styles from './LoadingSpinner.module.css';

export class LoadingSpinner extends Component {
    render() {
        const LoadingSpinnerStyles = classNames(
            this.props.className,
            styles.LoadingSpinner
        );

        return (
            <div
                data-testid={this.props['data-testid']}
                className={LoadingSpinnerStyles}
            >
                Loading...
            </div>
        );
    }
}
